<section class="studies-area" *ngIf="studies?.length > 0">
  <div class="row p-0 m-0">
    <div class="col-12 p-2">
      <div class="modal-header">
        <h5 class="modal-title w-100">
          <button type="button" class="btn ps-2 pe-2 rounded-circle btn-sm btn-success"><i class="fa fa-check"></i></button>
          Following Studies Have Been Created
        </h5>
        <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="closeStudies()"
                ></button>
      </div>
      <div class="modal-body mt-2">
        <div class="row p-0 m-0" *ngFor="let study of studies; let i = index; let last = last">
          <div class="col">
            <p>{{study.studyId}} - {{study.patientName}}</p>
            <p>Created At: {{study.studyDateTime | date: 'MMM dd, yyyy h:mm a'}}</p>
            <p>Study Date: {{study.createdDate | date: 'MMM dd, yyyy h:mm a'}}</p>
            <a href="javascript:void(0)" (click)="NavigateToStudy(study.studyId)">View Study</a>
            <hr *ngIf="!last">
          </div>
          
        </div>

      </div>
    </div>
  </div>
</section>
<section class="progress-area" [ngClass]="{ 'disable-container': isLoader }" *ngIf="files?.length > 0">
  <div class="spinner-overlay" *ngIf="isLoader">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <mat-accordion>
    <mat-expansion-panel expanded="true" #matExpansionPanel>
      <mat-expansion-panel-header class="file-upload-header">
        <div class="my-panel" (click)="$event.stopPropagation();">
          <mat-panel-title>
            Study Files
          </mat-panel-title>
          <mat-panel-description class="justify-content-end" *ngIf="!hasAllFilesErrors()">
            <mat-progress-bar mode="indeterminate" *ngIf="!isResume"></mat-progress-bar>

          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>

      <div class="row">
        <div class="col-12 p-2">
          <div *ngFor="let group of (files | sortBy: 'batchId' | groupBy: 'batchId'); let last = last">
            <div class="row p-0 content-area">
              <div class="col ps-2 p-0">
                <div class="mb-2">
                  <h5 class="text-center mb-2">
                    <span class="title" *ngIf="group.value[0].saleName">
                      {{group.value[0].saleName}}
                      <br />
                      {{lotOrHipText}} <span>-</span>
                      {{group.value[0].lot}}
                    </span>
                    <span class="title" *ngIf="!group.value[0].saleName">
                      Clinical Data
                    </span>
                  </h5>
                  <h5 class="text-center batch-title mb-2">
                    {{getDateFromNetTicks(group.key) | date:'MMM dd, yyyy h:mm a'}}
                  </h5>
                </div>
                <table>
                  <tbody>
                    <tr class="upload-item-row" *ngFor="let item of group.value | sortBy: 'id'">
                      <td style="width: 16px;">
                        <i class="fa fa-file-upload" style="font-size: 24px"></i>
                      </td>
                      <td class="uploaderFilename">
                        <div class="ellipsis">
                          {{item.file.name}}
                        </div>
                        <span *ngIf="item.error" class="text-danger">
                          <i class="fa fa-exclamation-circle"></i> {{item?.error}}
                        </span>
                        <div class="progress-bar" *ngIf="!item.error && item?.progress > 0">
                          <div class="progress" [style.width.%]="item?.progress ?? 0"></div>
                        </div>
                      </td>
                      <td style="width: 46px;">
                        <span class="percent ps-2" *ngIf="!item.error">{{item?.progress ?? 0}}%</span>
                      </td>
                      <td style="width: 12px;">
                        <button class="btn btn-warning btn-round ml-6 btn-pause-bg" [disabled]="item.disablePause" *ngIf="item.isPause == false"
                                (click)="pauseChunkFile(item)">
                          <i class="fa fa-pause"></i>
                        </button>
                        <button class="btn btn-warning btn-round ml-6 btn-pause-bg" [disabled]="item.disablePlay" *ngIf="item.isPause == true"
                                (click)="resumeChunkFile(item)">
                          <i class="fa fa-play"></i>
                        </button>
                      </td>
                      <td>

                        <button class="btn btn-danger btn-round ml-6 btn-trash-bg" [disabled]="item.disableDelete"
                                (click)="removeChunkFile(item)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr style="border-width: 2px;" *ngIf="!last">
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</section>
